module.exports = __webpack_public_path__ + "files/93132dd2f75358feacfbdca600331aed.png";